<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Invoices</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">
  <div class="d-flex justify-content-end mb-2">
    <button type="button" class="btn btn-success btn-sm" (click)="addInvoice()">
      <fa-icon [icon]="faPlus"></fa-icon> Add Invoice
    </button>
  </div>

  <div class="table-responsive m-2">
    <table class="table table-sm table-hover mb-0 small">
      <thead>
        <tr>
          <th>Invoice Type</th>
          <th>Invoice Number</th>
          <th>Created By</th>
          <th>Status</th>
          <th>Invoiced Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invoice of invoices"
            (dblclick)="openInvoice(invoice.id)"
            style="cursor: pointer;"
            [ngClass]="{
              'table-success': invoice.klyantInvoiceId != null,
              'table-warning': invoice.invoiceGeneratedDate != null && invoice.klyantInvoiceId == null
            }">
          <td>{{invoice.description}}</td>
          <td>{{invoice.invoiceNumber}}</td>
          <td>{{invoice.createdByUser.fullName}}</td>
          <td>
            <span *ngIf="invoice.invoiceGeneratedDate == null">Invoice File not Generated </span>
            <span *ngIf="invoice.invoiceGeneratedDate != null && invoice.klyantInvoiceId == null">Invoice File Generated</span>
            <span *ngIf="invoice.klyantInvoiceId != null">SENT TO KLYANT</span>
          </td>
          <td>
              {{invoice.invoiceGeneratedDate | date:'dd/MM/yyyy HH:mm'}}
          </td>
          <td class="text-end">
            <fa-icon [icon]="faTimes" class="text-danger me-2" style="cursor: pointer;"
              (click)="archiveInvoice(invoice.id, invoice.klyantInvoiceId)"></fa-icon>
            <fa-icon *ngIf="invoice.klyantInvoiceId == null && invoice.invoiceNumber && !invoice.sendingToClient"
              [icon]="faShare" class="text-success" style="cursor: pointer;"
              (click)="sendToKlyant(invoice)"></fa-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>